import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';
import { trigger, transition, useAnimation, group, animate, style, state, AnimationEvent } from '@angular/animations';
import { fadeIn, fadeOut } from 'ng-animate';
import { CampusWard, CampusStake, SortService } from '../../../shared';

const fadeInParams = {params: { timing: .65 }};
const fadeOutParams = {params: { timing: .25, delay: 0}};

@Component({
  selector: 'app-campus-unit-selection',
  templateUrl: './campus-unit-selection.component.html',
  styleUrls: ['./campus-unit-selection.component.scss'],
  animations: [
    trigger('fadeInDelay', [transition(':enter', [
      group([
        animate('0s', style({ opacity: 0 })),
        useAnimation(fadeIn, fadeInParams)])])]),
    trigger('fadeOut', [transition(':leave', useAnimation(fadeOut, fadeOutParams))])
  ]
})
export class CampusUnitSelectionComponent implements OnChanges {

  @Input() unitType: string;
  @Input() married: boolean;
  @Input() campusWards: CampusWard[];
  @Input() campusStakes: CampusStake[];

  filteredCampusStakes: CampusStake[];
  selectedCampusStake: CampusStake;
  filteredCampusWards: CampusWard[];
  selectedCampusWard: CampusWard;

  constructor(private sorter: SortService) { }

  ngOnChanges(changes: SimpleChanges) {
    const wardsChange = changes['campusWards'];
    if (wardsChange != null) {
      this.onCampusWardChange();
    }

    const stakesChange = changes['campusStakes'];
    if (stakesChange != null) {
      this.onCampusStakeChange();
    }

    const marriedChange = changes['married'];
    if (marriedChange != null) {
      this.filterChurchUnits();
    }

    const unitTypeChange = changes['unitType'];
    if (unitTypeChange) {
      if (unitTypeChange.currentValue === 'ward') {
        this.onCampusWardChange();
      } else {
        this.onCampusStakeChange();
      }
    }
  }

  /**
   * Filters our list of campus wards and stakes to either only contain single wards/stakes or married wards/stakes based on selection.
   */
  filterChurchUnits(): void {
    // based on our selection, we need to update our lists of wards/stakes that are being shown
    this.selectedCampusStake = null;
    this.selectedCampusWard = null;

    this.onCampusWardChange();
    this.onCampusStakeChange();
  }

  /**
   * Filters the campus wards that can be picked from based on whether or not we are working with married wards or not.
   */
  onCampusWardChange() {
    if (!this.campusWards) {
      return;
    }

    if (this.married) {
      this.filteredCampusWards = this.campusWards.filter(ward => {
        return ward.isForMarriedStudents;
      });
    } else {
      this.filteredCampusWards = this.campusWards.filter(ward => {
        return !ward.isForMarriedStudents;
      });
    }
  }

  /**
   * Filters the campus stakes that can be picked from based on whether or not we are working with married wards or not.
   */
  onCampusStakeChange(stakeName?: string) {
    if (!this.campusStakes) {
      return;
    }

    if (this.married) {
      this.filteredCampusStakes = this.campusStakes.filter(stake => {
        return stake.isForMarriedStudents;
      });
    } else {
      this.filteredCampusStakes = this.campusStakes.filter(stake => {
        return !stake.isForMarriedStudents;
      });
    }
  }
}
